// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.queryFormClass[data-v-97d37a42] {\n  margin-bottom: 10px;\n}\n.pagination-container[data-v-97d37a42] {\n  margin-top: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
